import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { CmsLoaderService } from './service/cms-loader.service';
import { CMS_WIDGETS } from './service/cms-tokens';
import { cmsArrayToObj } from './service/cms-widgets';
import { CmsGeneratorComponent } from './cms-generator/cms-generator.component';


export const routes: Routes = [
  { path: '', component: CmsGeneratorComponent}
];

@NgModule({
  declarations: [CmsGeneratorComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    CmsLoaderService,
    { provide: CMS_WIDGETS, useFactory: cmsArrayToObj }
  ]
})
export class CmsGeneratorModule { }
